// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__eS3-I","loaderOuter":"PageOverlayLoader_loaderOuter__Wl4_9"};